module.exports = __webpack_public_path__ + "img/stars.29156101.png";